import { useBreakpoint } from '@orn/shared-web/hooks/useBreakpoint';
import { cx } from '@orn/shared-web/utils/cx';

import { formatAccountSubtype } from '../../utils/accounts';
import SyncStatus from '../SyncStatus';

import type { FinancialAccountSubtype } from '../../__generated__/globalTypes';

interface IAccountMetadataProps {
  className?: string;
  subtype?: FinancialAccountSubtype;
  bankName: string;
  mask: string;
  lastSyncedAt?: string;
}

const AccountMetadata = ({ className, subtype, bankName, mask, lastSyncedAt }: IAccountMetadataProps) => {
  const isSmOrUp = useBreakpoint('sm');
  const accountSubtypeLabel = subtype ? formatAccountSubtype(subtype) : '';

  // Responsive: on sm and up show full metadata (subtype | bank | mask | sync). On smaller
  // viewports show only sync status when available, otherwise subtype + bank name to save space.
  const separator = <span className="text-quaternary shrink-0">|</span>;

  const subtypeAndBank = (
    <>
      {accountSubtypeLabel && <span className="shrink-0">{accountSubtypeLabel}</span>}
      {accountSubtypeLabel && separator}
      <span className="min-w-0 truncate">{bankName}</span>
    </>
  );

  const syncStatus = lastSyncedAt ? (
    <SyncStatus className="shrink-0 px-1" lastSyncedAt={lastSyncedAt} addPrefix={true} />
  ) : null;

  const content = isSmOrUp ? (
    <>
      {subtypeAndBank}
      {separator}
      <span className="shrink-0">••{mask}</span>
      {lastSyncedAt && separator}
      {syncStatus}
    </>
  ) : lastSyncedAt ? (
    syncStatus
  ) : (
    subtypeAndBank
  );

  return (
    <div className={cx('text-tertiary flex min-w-0 max-w-full items-center gap-1 font-normal', className)}>
      {content}
    </div>
  );
};

export default AccountMetadata;
